import React from 'react';
import PropTypes from 'prop-types';
import Translate from './Translate';
import {decodeEntities} from '../api/utils';
import RentalInformationHOC from '../hoc/RentalInformationHOC';
import VariableCosts from './VariableCosts';
import StatusMessage from './StatusMessage/StatusMessage';
import ProductByline from './formatterComponents/ProductByline';
import translator from '../translations/drupalTranslator';
import FreeCancellationInfo from "./FreeCancellationInfo";

const RentalInformation = ({services, rental}) => (
  <section className="booking-step" id="booking-info-wrap">
    <div className="booking-step__inner">
      <div className="booking-step__inner2">
        <StatusMessage
          labels={{
            paymentDeclineTitle: translator.translate('Booking unsuccessful'),
            paymentDecline: translator.translate('Payment was unsuccessful please try with a different payment method'),
          }}
        />
        <div className="house-header">
          <h1>
            {decodeEntities(rental.location)}
            ,
            {' '}
            {decodeEntities(rental.countryName)}
          </h1>
          <h2>
            <Translate content="Property ID" />
            :
            {' '}
            {rental.propertyId}
          </h2>
          {rental.information.productCode && (
            <ProductByline rental={rental} />
          )}
        </div>

        <div className="group property-info" id="property-info-wrap">
          <div id="property-img" style={{'backgroundImage': `url(${rental.imageUrl})`}} />
          <VariableCosts services={services} />
          {rental.freeCancellation && (
            <FreeCancellationInfo />
          )}
        </div>
      </div>
    </div>
  </section>
);

RentalInformation.PropTypes = {
  rental:PropTypes.shape({
    location:PropTypes.string.isRequired,
    propertyId:PropTypes.string.isRequired,
    imageUrl:PropTypes.string.isRequired,
  }).isRequired,
  services:PropTypes.array.isRequired,
};

export default RentalInformationHOC(RentalInformation);
